import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import Button from 'components/Button';
import AskModal from 'components/Modals/AskModal';
import styles from './Intro.module.css';

const Intro = () => {
  const [showAskModal, setShowAskModal] = useState<boolean>(false);

  return (
    <div className={styles.intro}>
      <div className={styles.intro__container}>
        <div className={styles.wrapper}>
          <div className={styles.intro__content}>
            <div className={styles.intro__text_section}>
              <h1 className={styles.intro__title}>
                Учи.Ответы на&nbsp;2&nbsp;миллиона вопросов
              </h1>
              <div className={styles.intro__links}>
                по
                <Link href="/categories/matematika">
                  <a className={styles.intro__link}>математике</a>
                </Link>
                ,
                <Link href="/categories/russkiy-yazyk">
                  <a className={styles.intro__link}>русскому языку</a>
                </Link>
                ,
                <Link href="/categories/literatura">
                  <a className={styles.intro__link}>литературе</a>
                </Link>
                , и
                <Link href="/categories">
                  <a className={styles.intro__link}>другим школьным предметам</a>
                </Link>
              </div>
              <Button
                className={styles.intro__btn}
                text="Задать вопрос"
                onClick={() => setShowAskModal(true)}
              />
            </div>
            <div className={styles.intro__images_container}>
              <div className={`${styles.intro__card} ${styles.intro__card_first}`}>
                <Image
                  src="https://static.uchi.ru/files/otvety/main/main_intro_card1.svg"
                  width={344}
                  height={120}
                  alt=""
                  priority
                />
              </div>
              <div className={`${styles.intro__card} ${styles.intro__card_second}`}>
                <Image
                  src="https://static.uchi.ru/files/otvety/main/main_intro_card2.svg"
                  width={344}
                  height={95}
                  alt=""
                  priority
                />
              </div>
              <div className={`${styles.intro__card} ${styles.intro__card_third}`}>
                <Image
                  src="https://static.uchi.ru/files/otvety/main/main_intro_card3.svg"
                  width={344}
                  height={101}
                  alt=""
                  priority
                />
              </div>
              <div className={`${styles.intro__card} ${styles.intro__card_fourth}`}>
                <Image
                  src="https://static.uchi.ru/files/otvety/main/main_intro_card4.svg"
                  width={344}
                  height={101}
                  alt=""
                  priority
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAskModal && (
        <AskModal onClose={() => setShowAskModal(false)} tryCreateNew="question" />
      )}
    </div>
  );
};

export default Intro;
